import UilAngleDown from '@iconscout/react-unicons/icons/uil-angle-down';
import UilSignout from '@iconscout/react-unicons/icons/uil-signout';
import { Avatar } from 'antd';
import Cookies from 'js-cookie';
import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Heading from '../../components/heading/heading';
import { Popover } from '../../components/popup/popup';
import { DataService } from '../../config/dataService/dataService';
import { useAuthenticationStore } from '../../store/authentication/authenticationStore';
import { RoleNames } from '../../utility/constants';
import { InfoWraper, UserDropDwon } from './style';
import profileImage from '../../static/img/avatar/profileImage.png';

// import { useDispatch } from 'react-redux';
// import { logOut } from '../../redux/authentication/actionCreator';

const AuthInfo = React.memo(() => {
  // const dispatch = useDispatch();
  const navigate = useNavigate();
  const doLogout = useAuthenticationStore((st) => st.doLogout);
  const SignOut = async (e) => {
    e.preventDefault();
    await DataService.post('/admin/auth/logout');
    doLogout();
    // dispatch(logOut(() => navigate('/')));

    navigate('/');
  };

  const userContent = (
    <UserDropDwon>
      <div className="user-dropdwon">
        <figure className="user-dropdwon__info">
          <img height="40" src={profileImage} alt="" />
          <figcaption>
            <Heading as="h5">{Cookies.get('name')}</Heading>
            <p>{RoleNames[Cookies.get('role')] || ''}</p>
          </figcaption>
        </figure>

        <Link className="user-dropdwon__bottomAction" onClick={SignOut} to="#">
          <UilSignout /> Sign Out
        </Link>
      </div>
    </UserDropDwon>
  );

  return (
    <InfoWraper>
      <div className="ninjadash-nav-actions__item ninjadash-nav-actions__author">
        <Popover placement="bottomRight" content={userContent} action="click">
          <Link to="#" className="ninjadash-nav-action-link">
            <Avatar src={profileImage} />
            <span className="ninjadash-nav-actions__author--name">{Cookies.get('name')}</span>
            <UilAngleDown />
          </Link>
        </Popover>
      </div>
    </InfoWraper>
  );
});

AuthInfo.displayName = 'AuthInfo';
export default AuthInfo;
